import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/api-tokens/new")({
  staticData: {
    title: "apiTokens.panel.createTitle",
  },
});
